angular.module('impactx.invoice').controller('InvoiceListAdminCtrl', [
    'DownloadService',
    'selectedListItems',
    InvoiceListAdminCtrl]);

function InvoiceListAdminCtrl(DownloadService, selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewInvoice'
        },
        {
            label: "downloadPDF",
            action: downloadPDF,
            condition: function () {
                return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDownloadPDF;
            }
        },
        {
            label: "downloadXML",
            action: downloadXML,
            condition: function () {
                return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDownloadXML;
            }
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/invoice/templates/invoicelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/invoice/listadmin',
        id: "invoicelistadmin",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function downloadPDF() {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        DownloadService.openDownloadPost('/invoice/download/pdf', {paramName: "id", paramValue: selectedItem.invoiceInfoId});
    }

    function downloadXML() {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        DownloadService.openDownloadPost('/invoice/download/xml', {paramName: "id", paramValue: selectedItem.invoiceInfoId});
    }

    function getDetailLink() {
        return "invoiceview/" + selectedListItems.getFirstSelectedId();
    }
}